/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
import { takeEvery, call, put, all, takeLatest } from "redux-saga/effects";
import * as actionTypeConf from "../config/actionType";
import * as actions from "../action/trajetAction";
import * as trajetServices from "../services/trajetService";

function* watchLoadTrajet() {
  yield takeLatest(actionTypeConf.LOAD_TRAJET, loadTrajet);
}

function* loadTrajet(dataTrajet) {
  try {
    const positions = yield call(trajetServices.getListPosition, dataTrajet);
    yield put(actions.trajetActionLoaded(positions));
  } catch (e) {
    // console.log(e)
  }
}

function* watchLoadTrajetNew() {
  yield takeLatest(actionTypeConf.LOAD_TRAJET_NEW, loadTrajetNew);
}

function* loadTrajetNew(dataTrajet) {
  try {
    const trajets = yield call(trajetServices.getListTrajet, dataTrajet);
    yield put(actions.trajetActionNewLoaded(trajets));
  } catch (e) {
    console.log(e);
  }
}

export function* trajetSaga() {
  yield all([watchLoadTrajet(), watchLoadTrajetNew()]);
}
